import type { ElementType } from '@react-spring/web';

import { Box } from '../box/box';
import type { UserMenuProps } from '../user-menu/user-menu';
import { UserMenu } from '../user-menu/user-menu';

import * as styles from './top-bar.css';

export interface TopBarProps extends UserMenuProps {
  NavLink: ElementType;
}

export const TopBar = ({
  email,
  role,
  logOutText,
  logOutHref,
  NavLink,
}: TopBarProps) => (
  <Box
    className={styles.topBar}
    alignContent={{ x: 'center', y: 'center' }}
    padding={{ x: 'basePos4', y: 'basePos3' }}
    spacing="baseNeg2"
    role="complementary"
  >
    <Box alignContent={{ x: 'right', y: 'center' }} stack="row">
      <UserMenu
        role={role}
        logOutText={logOutText}
        logOutHref={logOutHref}
        email={email}
        NavLink={NavLink}
      />
    </Box>
  </Box>
);
